import { render, staticRenderFns } from "./QuickInsights.vue?vue&type=template&id=2d5e4f32&scoped=true&"
import script from "./QuickInsights.vue?vue&type=script&lang=js&"
export * from "./QuickInsights.vue?vue&type=script&lang=js&"
import style0 from "./QuickInsights.vue?vue&type=style&index=0&id=2d5e4f32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5e4f32",
  null
  
)

export default component.exports